// extracted by mini-css-extract-plugin
export default {"controlButton":"pVM1ey","hidden":"pE6VGN","container":"VH7UEc","frame":"P_YO_v"};